import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';

@Component({
  selector: 'common-social-logindisable-banner',
  templateUrl: './social-logindisable-banner.component.html',
  styleUrl: './social-logindisable-banner.component.scss'
})
export class SocialLogindisableBannerComponent implements OnInit{
  cleverTapEventsService: any;
  recalculateHeightService: any;
  sessionStorageService: any;
  universalService: any;
  localStorageService: any;
  router: any;
  userData: any;

  constructor(public globalService:GlobalService) { 
    this.setEnvObjects(globalService);
  }
  ngOnInit(): void {
    this.userData = this.localStorageService.getUserData(true);
    this.EmitEventForContainersToRecalculateHeight();
  }

  setEnvObjects(globalService){
    this.router = globalService.getRouterRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.recalculateHeightService = globalService.getContainerHeightCalculatorService();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
  }

  redirectToDataExport(){
    let elArray = document.querySelectorAll('.left-menu-selected-item')
    elArray.forEach(e =>{
      if(e){
        e.classList.remove('left-menu-selected-item')
      }
    });
    this.universalService.headingTitle.set("Create Export");
    this.router.navigate(['/dataexport']);
  }

  EmitEventForContainersToRecalculateHeight(){
    setTimeout(() => { 
      this.recalculateHeightService.sendRecalculateEventToComponents(true);
    }, 1000);
  }
}
